<template>
  <el-container class="recharge">

    <el-header class="search">
      <el-select
          v-model.number="subjectState"
          placeholder="资源状态"
          style="width: 125px; margin:0 10px 0 -20px"
          @change="BtnQuery"
        >
          <el-option v-for="item in stateData"
          :key="item.value"
          :label="item.name"
          :value="item.value"
          ></el-option>
        </el-select>

      <el-input class="search-text" v-model="keyWord" placeholder="请输入关键字检索..." @keyup.enter.native="BtnQuery"></el-input>
      <el-button type="primary" size="medium" plain icon="el-icon-search" @click="BtnQuery">查询</el-button>
    </el-header>

    <el-main>
      <div v-if="data.length > 0" class="recharge-data">
          <div v-for="item in data" :key='item.ExamId'>
            <el-descriptions :title="item.TypeName" class="descript">
                <template slot="extra">
                  <el-button v-if="item.state===1" type="primary" size="small" plain @click="goStady(item)">前往学习</el-button>
                  <el-button v-if="item.state!==1" type="danger" size="small" plain
                    @click="rebuy(item)"
                  >重新购买</el-button>
                </template>
                <el-descriptions-item label="有效期">
                  <el-tag type="success" size="mini">{{item.ChargeTimeStr}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="过期时间">
                  {{item.ExpireTime}}
                  <el-tag v-if="item.state!==1" type="danger" size="mini">已过期</el-tag>
                </el-descriptions-item>
            </el-descriptions>
          </div>
      </div>
      <empty-data v-else></empty-data>
    </el-main>

    <el-footer v-if="data.length > 0" class="pagaing">
      <el-pagination
            :background="true"
            :current-page="pageIndex"
            :page-size="PageSize"
            :total="total"
            :layout="pageLayout"
            @current-change="PageChange"
            @size-change="SizeChange"
          ></el-pagination>
    </el-footer>

    <el-dialog class="classification" :visible.sync="showPopu" width="30%" :showConfirmButton="false" :showCancelButton="false"
      @close="closeDiolog"
      title="请选择要前往的类目"
      center
     >
    <div slot="default" class="jf itemActive">
        <div class="font-size18  tit  item" v-for="(info,index) in ColumnInfo" :key="index" @click="jumpCategory(info)">
          <div>
            <img v-if="index === 0" class="navImgWidth" src="@/assets/img/test.png" alt="">
          <img v-else-if="index === 1" class="navImgWidth" src="@/assets/img/chapter.png" alt="">
          <img v-else-if="index === 2" class="navImgWidth" src="@/assets/img/questions.png" alt="">
          <img v-else class="navImgWidth" src="@/assets/img/confirm.png" alt="">
          </div>
          <div class="text font-size14 xy-center">
            {{info.name}}
            </div>
        </div>
    </div>
    </el-dialog>

  </el-container>
</template>

<script>

import { GetUserConsumeRecord, GetColumnInfo } from "@/api/category";
import { GetSystemCategoryInfo } from "@/api/course";
import EmptyData from "@/components/EmptyData";
import { treeToArray } from "@/utils";

export default {
    components: { EmptyData },
    data() {
        return {
            listLoading: false,
            loadingText: "正在加载...",
            pageLayout: "total, sizes, prev, pager, next, jumper",
            subjectState: 0,
            stateData: [
                { value: 0, name: "全部" },
                { value: 1, name: "正常" },
                { value: 2, name: "已过期" }
            ],
            PayMethod: null,
            payMethodData: [
                { value: 0, name: "全部" },
                { value: 1, name: "充值卡" },
                { value: 2, name: "微信" },
                { value: 3, name: "支付宝" }
            ],
            pageIndex: 1,
            PageSize: 10,
            total: 0,
            keyWord: "",
            // 列表记录
            data: [],
            ColumnInfo: [],
            showPopu: false,
            allColumn: [],
            currentColums: [],
            currentSelectResourceId: ""
        }
    },
    computed: {},
    watch: {},
    created() {
        this.ConsumeData()
        this.GetSystemCategoryInfo()
    },
    methods: {
        // 获取所有科目
        async GetSystemCategoryInfo() {
            try {
                const {
                    data
                } = await GetSystemCategoryInfo()
                let arr = data.data
                arr.forEach((v, i) => {
                    v.Ids = []
                    v.Ids.push(v.id)
                })
                this.cycAddIds(arr)
                this.allColumn = arr
            } catch (err) {
                this.$message("删除发生异常！", "error")
            }
        },
        cycAddIds(arr) {
            arr.forEach(v => {
                if (v.children && v.children.length !== 0) {
                    v.children.forEach(c => {
                        c.Ids = []
                        c.Ids.push(...v.Ids)
                        c.Ids.push(c.id)
                    })
                    this.cycAddIds(v.children)
                }
            })
        },
        closeDiolog() {
            this.showPopu = false
        },
        jumpCategory(val) {
            this.cycSelectColum(this.allColumn, this.currentSelectResourceId, val.id)
        },
        cycSelectColum(arr, ID, categoryId) {
            const res = treeToArray(arr).find(item => item.id === ID)
            if (res) {
                this.$router.push({ path: "/question/public", query: { from: "buy", queryId: JSON.stringify(res.Ids), categoryId } })
            }
            // for (const v of arr) {
            //     if (v.id === ID) {
            //         this.currentColums = []
            //         this.currentColums = v.Ids
            //         this.$router.push({ path: "/question/public", query: { from: "buy", queryId: JSON.stringify(this.currentColums), categoryId } })
            //         break;
            //     } else {
            //         if (v.children && v.children.length !== 0) {
            //             this.cycSelectColum(v.children, ID, categoryId)
            //         }
            //     }
            // }
        },

        goStady(val) {
            let id = val.TypeId.trim()
            this.currentSelectResourceId = id
            // this.cycSelectColum(this.allColumn, id)
            this.showPopu = true
            this.GetColumnInfo(val)
        },
        async GetColumnInfo(val) {
            try {
                const { data } = await GetColumnInfo({
                    categoryId: val.TypeId
                });
                if (data.code === 100) {
                    this.ColumnInfo = data.data;
                }
            } catch (err) {
                this.$toast("服务器繁忙，请稍后再试！");
            }
        },
        // 资源信息
        async ConsumeData() {
            const { data } = await GetUserConsumeRecord({
                pageno: this.pageIndex,
                pagesize: this.PageSize,
                PayMethod: this.PayMethod,
                expired: this.subjectState,
                searchKey: this.keyWord,
                sortBy: "PayTime",
                sordOrder: "Desc"
            });
            if (data.code === 100) {
                let currentTime = new Date().getTime()
                for (let item of data.data) {
                    item.ChargeTimeStr = "";
                    if (item.ChargeTime === "1") {
                        item.ChargeTimeStr = "一个月"
                    } else if (item.ChargeTime === "2") {
                        item.ChargeTimeStr = "三个月"
                    } else if (item.ChargeTime === "3") {
                        item.ChargeTimeStr = "六个月"
                    } else if (item.ChargeTime === "4") {
                        item.ChargeTimeStr = "一年"
                    } else {
                        item.ChargeTimeStr = "其它"
                    }

                    let subjectTime = new Date((item.ExpireTime).replace(/-/g, "/")).getTime()
                    if (parseInt(currentTime) < parseInt(subjectTime)) {
                        item.state = 1
                    }
                }
                this.data = data.data
                this.total = data.count
            }
        },
        // 按钮检索
        BtnQuery() {
            this.pageIndex = 1;
            this.PageSize = 10;
            this.ConsumeData()
        },
        PageChange(val) {
            this.pageIndex = val;
            this.ConsumeData()
        },
        //
        SizeChange(val) {
            this.PageSize = val;
            this.ConsumeData()
        },
        // 重新购买
        rebuy(item) {
            this.$router.push({
                name: "resourceOrder",
                query: {
                    columId: item.TypeId.replace(/^\s+|\s+$/g, "")
                }
            })
        }
    }
}

</script>

<style scoped lang="less">

  .recharge {
      width: 100%;
      height: 100%;

    .el-main{
      padding: 0 0 5px 0;
      color: black;
      height: 600px;
      overflow: auto;
     &::-webkit-scrollbar {
           width: 6px;
       }

       &::-webkit-scrollbar-track {
           border-radius: 6px;
       }

       &::-webkit-scrollbar-thumb {
           border-radius: 6px;
           background: #BAC0CA;
       }
    }

   .el-footer{
      height: 50px;
      line-height: 50px;
      text-align: center;
      margin-top: 40px;
    }

      .search{
        width: 100%;
        height: 40px;
        line-height: 40px;

        .search-select{
          width:130px;
        }

        .search-text{
          width:250px;
          margin:0 20px 0 0;
        }

        ::v-deep .el-input__inner{
          height: 35px;
        }

      }

    .recharge-data{
       padding: 10px 0 -10px 0;
       color: black;

       .descript{
        border-bottom:1px solid #e5e8ec;
        padding:0 30px 0 10px
      }

      ::v-deep .el-descriptions__header{
        margin: 10px 0 5px 0;
      }

    }

    .classification{
      .itemActive{
        .item{
          margin-left: 30px;
          img{
            width: 60px;
          }
          .text{
            width: 60px;
          }
        }
      }
    }

  }

</style>
